import * as cashboxesActions from "../stores/actions/cashbox";
import Http from "../utils/Http";
import { cashbox } from "stores/models/Cashbox";
import { cashbox_extra_fee } from "stores/models/CashboxExtraFee";
import { serializeSearchInput, serializeInput } from "utils/helpers";

import * as authActions from "../stores/actions/auth";

export function fetchCashboxes(pageNumber = 1, input = [], other_input = []) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      let url = `cashboxes-v2${input.length > 0 ? serializeSearchInput(input) : ""}${
        other_input.length > 0 ? (input.length > 0 ? "&" : "?") : ""
      }${serializeInput(other_input)}`;
      Http.get(
        url +
          (pageNumber
            ? (input.length > 0 || other_input.length > 0 ? "&" : "?") +
              "page=" +
              pageNumber
            : ""),
      )
        .then((res) => {
          let cashboxes = [];
          res.data.data.forEach((element) => {
            cashboxes.push(cashbox(element));
          });
          dispatch(cashboxesActions.fetchCashboxesResolved(cashboxes));
          return resolve(res.data);
        })
        .catch((error) => {
          dispatch(cashboxesActions.fetchCashboxesFailed(error));
          dispatch(authActions.serverError(error.error));
          return reject(error);
        });
    });
}
export function fetchCashboxDetails(cashboxId) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      let url = `cashbox-settings-v2/${cashboxId}`;
      Http.get(url)
        .then((res) => {
          const data = res.data;
          if (data.cashbox) {
            dispatch(
              cashboxesActions.fetchCashboxDetailsResolved(data.cashbox),
            );
          } else {
            dispatch(cashboxesActions.fetchCashboxDetailsResolved({}));
          }
          return resolve(data);
        })
        .catch((error) => {
          dispatch(cashboxesActions.fetchCashboxDetailsFailed(error));
          dispatch(authActions.serverError(error.error));
          return reject(error);
        });
    });
}


export function exportCashboxes(input = []) {
  const urlBase = `cashboxes/v2/export`;
  let url = urlBase;
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.post(url, input)
        .then((res) => {
          dispatch(authActions.serverSuccess(res.data.message));
          return resolve(res.data);
        })
        .catch((err) => {
          dispatch(authActions.serverError(err.error));
          return reject(err);
        });
    });
}

export function exportMultipleCashboxDetailsPdf(cashboxIds, fileName) {
  const urlBase = "cashboxes/v2/export-details";
  const requestBody = {
    format: 'pdf',
    cashboxIds: cashboxIds
  };
  
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.post(urlBase, requestBody)
        .then((res) => {
          dispatch(authActions.serverSuccess(res.data.message || 'Cashbox details exported successfully. The PDF will be sent to your email.'));
          return resolve(res.data);
        })
        .catch((err) => {
          dispatch(authActions.serverError(err.error || 'Failed to export cashbox details'));
          return reject(err);
        });
    });
}
export function exportCashboxDetailsPdf(cashboxId, fileName) {
  const urlBase = "cashboxes/v2/export-details";
  const requestBody = {
    format: 'pdf',
    cashbox_id: cashboxId
  };
  
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.post(urlBase, requestBody, { responseType: 'blob' })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'cashbox_report_' + fileName + '.pdf');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          dispatch(authActions.serverSuccess('PDF downloaded successfully.'));
          return resolve(res.data);
        })
        .catch((err) => {
          dispatch(authActions.serverError('Failed to generate PDF'));
          return reject(err);
        });
    });
}
export function exportCashboxDetailsExcel(cashboxId, fileName) {
  const urlBase = "cashboxes/v2/export-details";
  const requestBody = {
    format: 'excel',
    cashbox_id: cashboxId
  };
  
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.post(urlBase, requestBody)
        .then((res) => {
          dispatch(authActions.serverSuccess(res.data.message || 'Cashbox Details exported successfully'));
          return resolve(res.data);
        })
        .catch((err) => {
          dispatch(authActions.serverError('Failed to generate Excel'));
          return reject(err);
        });
    });
}
export function fetchCashbox(id) {
  return dispatch =>
    new Promise((resolve, reject) => {
      Http.get("cashboxes-v2/" + id)
        .then(res => {
          dispatch(cashboxesActions.fetchCashboxResolved(cashbox(res.data.data)));
          return resolve(res.data);
        })
        .catch(err => {
          dispatch(authActions.serverError(err));
          return reject(err);
        });
    });
}


export function updateCashbox(input, remove = false) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.put("cashboxes/v2/" + input.id, input.data)
        .then((res) => {
          dispatch(
            cashboxesActions.updateCashboxResolved(
              cashbox(res.data.data),
              remove,
            ),
          );
          dispatch(authActions.serverSuccess(res.data.meta.message));
          return resolve(res.data.meta.message);
        })
        .catch((err) => {
          if (err.errors) {
            const validationErrors = err.errors;
            const errorMessages = Object.values(validationErrors)
              .flat()
              .join("; ");
            err.error = errorMessages;
            dispatch(authActions.serverError(errorMessages));
          } else {
            dispatch(authActions.serverError(err.error));
          }
          return reject(err);
        });
    });
}

export function updateCashboxSettlement(input) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      const cashboxId = input.cashbox_id || input.id;
      const requestData = {
        data: {
          settlementDetails: input.data.settlementDetails.map(detail => ({
            currency: detail.currency || detail.currency_id,
            paymentType: detail.paymentType || detail.payment_type_id,
            amount: parseFloat(detail.amount) || 0
          }))
        }
      };
      
      Http.put("cashbox-details/v2/" + cashboxId, requestData)
        .then((res) => {
          dispatch(cashboxesActions.updateSettlementResolved(cashbox(res.data.data)));

          dispatch(authActions.serverSuccess(res.data.meta.message));
          return resolve(res.data);
        })
        .catch((err) => {
          if (err.errors) {
            const validationErrors = err.errors;
            const errorMessages = Object.values(validationErrors)
              .flat()
              .join("; ");
            err.error = errorMessages;
            dispatch(authActions.serverError(errorMessages));
          } else {
            dispatch(authActions.serverError(err.error || err.message || "An error occurred while updating settlement"));
          }
          return reject(err);
        });
    });
}
export function addExtraFees(input, remove = false) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.post("cashboxes/v2/" + input.id + "/add-extra-fees", input.data)
        .then((res) => {
          let cashbox_extra_fees = [];
          res.data.data.forEach((element) => {
            cashbox_extra_fees.push(cashbox_extra_fee(element));
          });

          dispatch(
            cashboxesActions.addCashboxExtraFeesResolved(cashbox_extra_fees),
          );
          dispatch(authActions.serverSuccess(res.data.meta.message));
          return resolve(res.data.meta.message);
        }).catch((err) => {
          if (err.errors) {
            const validationErrors = err.errors;
            const errorMessages = Object.values(validationErrors)
              .flat()
              .map((error) => {
                const messageParts = error.split(".");

                const message = messageParts[messageParts.length - 2];
                return message;
              })
              .join("; ");

            err.error = errorMessages;
            dispatch(authActions.serverError(errorMessages));
          } else {
            dispatch(authActions.serverError(err.error));
          }
          return reject(err);
        });
    });
}

export function fetchCashboxExtraFeesHistory(id) {
  return dispatch =>
    new Promise((resolve, reject) => {
      Http.get("cashboxes-v2/" + id + "/extra-fees-history")
        .then(res => {
          dispatch(cashboxesActions.fetchCashboxExtraFeesHistory(res.data.data));
          return resolve(res.data);
        })
        .catch(err => {
          dispatch(authActions.serverError(err.error));
          return reject(err);
        });
    });
}

export function fetchCashboxExtraFeesGrouped(id) {
  return dispatch =>
    new Promise((resolve, reject) => {
      Http.get("cashboxes/v2/" + id + "/extra-fees?group_by_currency=true")
        .then(res => {
          return resolve(res.data);
        })
        .catch(err => {
          dispatch(authActions.serverError(err.error));
          return reject(err);
        });
    });
}

export function fetchCashboxExtraFees(id) {
  return dispatch =>
    new Promise((resolve, reject) => {
      Http.get("cashboxes/v2/" + id + "/extra-fees")
        .then(res => {
          return resolve(res.data);
        })
        .catch(err => {
          dispatch(authActions.serverError(err.error));
          return reject(err);
        });
    });
}

export function deleteCashboxExtraFee(extraFeeId) {
  return dispatch =>
    new Promise((resolve, reject) => {
      Http.delete("cashboxes/v2/extra-fees/" + extraFeeId)
        .then(res => {
          dispatch(authActions.serverSuccess(res.data.message || "Extra fee deleted successfully"));
          return resolve(res.data);
        })
        .catch(err => {
          dispatch(authActions.serverError(err.error));
          return reject(err);
        });
    });
}

export function fetchCashboxHistory(id) {
  return dispatch =>
    new Promise((resolve, reject) => {
      Http.get("cashboxes-v2/" + id + "/cashbox-history")
        .then(res => {
          dispatch(cashboxesActions.fetchCashboxHistory(res.data.data));
          return resolve(res.data);
        })
        .catch(err => {
          dispatch(authActions.serverError(err.error));

          return reject(err);
        });
    });
}

export function cancelCashbox(input, remove = false) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.put("cashboxes-v2/" + input.id + "/cancel")
        .then((res) => {
          dispatch(
            cashboxesActions.updateCashboxResolved(
              cashbox(res.data.data),
              remove,
            ),
          );
          dispatch(authActions.serverSuccess(res.data.meta.message));
          return resolve(res.data.meta.message);
        })
        .catch((err) => {
          if (err.errors) {
            const validationErrors = err.errors;
            const errorMessages = Object.values(validationErrors)
              .flat()
              .join("; ");
            err.error = errorMessages;
            dispatch(authActions.serverError(errorMessages));
          } else {
            dispatch(authActions.serverError(err.error));
          }
          return reject(err);
        });
    });
}

export function fetchCashboxExtraFee(id) {
  return dispatch =>
    new Promise((resolve, reject) => {
      Http.get("cashboxes-v2/extra-fees/" + id)
        .then(res => {
          dispatch(cashboxesActions.fetchCashboxExtraFeeResolved(res.data.data));
          return resolve(res.data);
        })
        .catch(err => {
          dispatch(authActions.serverError(err.error));

          return reject(err);
        });
    });
}

export function updateCashboxExtraFee(input) {
  return dispatch =>
    new Promise((resolve, reject) => {
      Http.put("cashboxes/v2/extra-fees/" + input.id, input)
        .then(res => {
          dispatch(cashboxesActions.updateCashboxExtraFeeResolved(res.data.data));
          return resolve(res.data);
        })
        .catch(err => {
          return reject(err);
        });
    });
}

export function createCashboxOrders(input){
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.post("cashboxes/v2/create-multiple-orders", input)
        .then((res) => {
         let cashboxes = [];
         res.data.cashboxes.forEach((element) => {
           cashboxes.push(cashbox(element));
         });

         dispatch(cashboxesActions.createMultipleOrdersResolved(cashboxes));
         dispatch(authActions.serverSuccess(res.data.meta.message));
         return resolve(res.data.meta.message);
        }).catch((err) => {
          dispatch(authActions.serverError(err.error));
          return reject(err);
        });
    }); 
}
export function cancelCashboxes(input){
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.post("cashboxes/v2/cancel", input)
        .then((res) => {
         let cashboxes = [];
         res.data.cashboxes.forEach((element) => {
           cashboxes.push(cashbox(element));
         });

         dispatch(cashboxesActions.cancelCashboxesResolved(cashboxes));
         dispatch(authActions.serverSuccess(res.data.meta.message));
         return resolve(res.data.meta.message);
        }).catch((err) => {
          dispatch(authActions.serverError(err.error));
          return reject(err);
        });
    }); 
}
export function addCashbox(input){
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.post("cashboxes/v2/add-manual", input)
        .then((res) => {
         dispatch(cashboxesActions.AddCashboxResolved(res.data.data));
         dispatch(authActions.serverSuccess(res.data.meta.message));
         return resolve(res.data.meta.message);
        }).catch((err) => {
          dispatch(authActions.serverError(err.error));
          return reject(err);
        });
    }); 
}

export function bulkAddExtraFees(input) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.post("cashboxes/v2/extra-fees/bulk-create", input)
        .then((res) => {
          let successMessage = res.data.meta.message;
          
          if (res.data.meta.failed_count > 0) {
            const failedEntries = res.data.meta.failed_entries || [];
            const failedDetails = failedEntries.map(entry => 
              `Cashbox ${entry.cashbox_id}: ${entry.error}`
            ).join('; ');
            successMessage += ` (${res.data.meta.failed_count} failed: ${failedDetails})`;
          }
          
          dispatch(authActions.serverSuccess(successMessage));
          return resolve(res.data);
        })
        .catch((err) => {
          if (err.errors && err.statusCode === 422) {
            dispatch(authActions.serverError("Some entries have validation errors. Please check the table below."));
            return reject({
              ...err,
              isValidationError: true,
              validationErrors: err.errors
            });
          } else {
            dispatch(authActions.serverError(err.error || "Failed to process bulk extra fees"));
            return reject(err);
          }
        });
    });
}

export function createCashboxSelection(input = [], other_input = []) {
  const urlBase = "cashboxes/v2/selection";
  return (dispatch) =>
    new Promise((resolve, reject) => {
      let url = `${urlBase}${input.length > 0 ? serializeSearchInput(input) : ""}${
        other_input.length > 0 ? (input.length > 0 ? "&" : "?") : ""
      }${serializeInput(other_input)}`;

      Http.post(url)
        .then((res) => {
          dispatch(authActions.serverSuccess(res.data.message || 'Selection created.'));
          return resolve(res.data);
        })
        .catch((err) => {
          dispatch(authActions.serverError(err.error || 'Failed to create selection'));
          return reject(err);
        });
    });
}
export function cancelCashboxesBySelection(selectionId, excludedCashboxes = []) {
  const urlBase = "cashboxes/v2/cancel";
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.post(urlBase, { 
        selection_id: selectionId,
        excluded_cashbox_ids: excludedCashboxes
      })
        .then((res) => {
          // Backend returns queued message; may not return cashboxes list
          dispatch(authActions.serverSuccess(res.data.meta?.message || 'Cashboxes cancelled.'));
          return resolve(res.data);
        })
        .catch((err) => {
          dispatch(authActions.serverError(err.error || 'Failed to cancel by selection'));
          return reject(err);
        });
    });
}
export function createCashboxOrdersBySelection(selectionId, excludedCashboxes = []) {
  const urlBase = "cashboxes/v2/create-multiple-orders";
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.post(urlBase, { 
        selection_id: selectionId,
        excluded_cashbox_ids: excludedCashboxes
      })
        .then((res) => {
          dispatch(authActions.serverSuccess(res.data.meta?.message || 'Orders created.'));
          return resolve(res.data);
        })
        .catch((err) => {
          dispatch(authActions.serverError(err.error || 'Failed to create orders by selection'));
          return reject(err);
        });
    });
}
export function exportMultipleCashboxDetailsPdfBySelection(selectionId, fileName, excludedCashboxes = []) { 
  const urlBase = "cashboxes/v2/export-details";
  const requestBody = {
    format: 'pdf',
    selection_id: selectionId
  };
  
  if (excludedCashboxes && excludedCashboxes.length > 0) {
    requestBody.excluded_cashbox_ids = excludedCashboxes;
  }
  
  return (dispatch) => 
    new Promise((resolve, reject) => { 
      Http.post(urlBase, requestBody) 
        .then((res) => { 
          dispatch(authActions.serverSuccess(res.data.message || 'Cashbox details exported successfully. The PDF will be sent to your email.')); 
          return resolve(res.data); 
        }) 
        .catch((err) => { 
          dispatch(authActions.serverError(err.error || 'Failed to export cashbox details')); 
          return reject(err); 
        }); 
    }); 
}

export function includeOrdersInCashbox(cashboxId, orderIds) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.post(`cashboxes/v2/${cashboxId}/include-orders`, { order_ids: orderIds })
        .then((res) => {
          dispatch(authActions.serverSuccess(res.data.meta.message));
          return resolve(res.data);
        }).catch((err) => {
          dispatch(authActions.serverError(err.error));
          return reject(err);
        });
    }); 
}

export function excludeOrdersFromCashbox(cashboxId, orderIds) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      Http.post(`cashboxes/v2/${cashboxId}/exclude-orders`, { order_ids: orderIds })
        .then((res) => {
          dispatch(authActions.serverSuccess(res.data.meta.message));
          return resolve(res.data);
        }).catch((err) => {
          dispatch(authActions.serverError(err.error));
          return reject(err);
        });
    }); 
}

// Fetch Extra Fees Import History
export function fetchExtraFeesImportsV2(pageNumber = null) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      let url = `v2/imports?import_type=extra_fees` + (pageNumber ? `&page=${pageNumber}` : "");
      Http.get(url)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
}

// Fetch Failed Extra Fees for a specific import
export function fetchFailedExtraFeesV2(importId, pageNumber = null) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      let url = `cashboxes/v2/extra-fees/failed/${importId}` + (pageNumber ? `?page=${pageNumber}` : "");
      Http.get(url)
        .then((res) => {
          return resolve(res.data);
        })
        .catch((err) => {
          return reject(err);
        });
    });
}

// Revert Extra Fees Import V2
export function revertExtraFeesImportV2(importId) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      let url = `cashboxes/v2/extra-fees/revert/${importId}`;
      Http.post(url)
        .then((res) => {
          dispatch(authActions.serverSuccess(res.data.message || "Extra fees import reverted successfully"));
          return resolve(res.data);
        })
        .catch((err) => {
          // Dispatch error notification
          dispatch(authActions.serverError(err.error || "Failed to revert extra fees import"));
          // Reject with proper error format for component handling
          return reject({
            error: err.error || err.message || "Failed to revert extra fees import",
            statusCode: err.statusCode || err.status || 500
          });
        });
    });
}

// Create Single Extra Fees V2
export function createSingleExtraFees(payload) {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      const cashboxId = payload?.cashbox_id;
      const extraFeesData = payload?.extra_fees || [];

      console.log('=== CREATE SINGLE EXTRA FEES REQUEST ===');
      console.log('Endpoint: POST cashboxes/v2/extra-fees/create');
      console.log('Cashbox ID:', cashboxId);
      console.log('Request Payload:', JSON.stringify(payload, null, 2));
      console.log('Extra Fees Count:', extraFeesData.length);
      extraFeesData.forEach((item, index) => {
        console.log(`Item ${index + 1}:`, {
          client_id: item.client_id,
          type_id: item.type_id,
          accounting_currency_ref_id: item.accounting_currency_ref_id,
          amount: item.amount,
          amount_type: typeof item.amount
        });
      });
      console.log('========================================');
      
      Http.post("cashboxes/v2/extra-fees/create", payload)
        .then((res) => {
          dispatch(authActions.serverSuccess(res.data.meta?.message || "Extra fees created successfully"));
          // Refresh cashbox data
          if (cashboxId) {
            dispatch(fetchCashbox(cashboxId));
          }
          return resolve(res.data);
        })
        .catch((err) => {
          if (err.errors) {
            const validationErrors = err.errors;
            const errorMessages = Object.values(validationErrors)
              .flat()
              .join("; ");
            err.error = errorMessages;
            dispatch(authActions.serverError(errorMessages));
          } else {
            dispatch(authActions.serverError(err.error || "Failed to create extra fees"));
          }
          return reject({
            error: err.error || err.message || "Failed to create extra fees",
            statusCode: err.statusCode || err.status || 500
          });
        });
    });
}